<!-- Contacts Form -->
<div class="card">
  <div class="card-header border-0 pt-6">
    <div class="card-title">
      <h3 class="fw-bold m-0">Contact Information</h3>
    </div>
  </div>

  <div class="card-body pt-0">
    <form [formGroup]="contactsForm" (ngSubmit)="onSubmit()" novalidate>

      <!-- Logo Upload Section -->
      <div class="row mb-8">
        <div class="col-12">
          <div class="card border">
            <div class="card-body">
              <label class="d-block fw-semibold fs-6 mb-5">Logo</label>
              <style>
                .logo-input-placeholder {
                  background-image: url('assets/media/svg/files/blank-image.svg');
                }

                [data-bs-theme="dark"] .logo-input-placeholder {
                  background-image: url('assets/media/svg/files/blank-image-dark.svg');
                }
              </style>
              <div class="image-input image-input-outline logo-input-placeholder" data-kt-image-input="true">
                <div class="image-input-wrapper logo-input-wrapper w-125px h-125px" [style.background-image]="logoPreviewUrl ? 'url(' + logoPreviewUrl + ')' : ''"></div>
                <label class="btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow" data-kt-image-input-action="change" data-bs-toggle="tooltip" title="Change logo">
                  <i class="ki-duotone ki-pencil fs-7">
                    <span class="path1"></span>
                    <span class="path2"></span>
                  </i>
                  <input type="file" name="logo" accept=".png, .jpg, .jpeg" (change)="onLogoSelected($event)" />
                  <input type="hidden" name="logo_remove" />
                </label>
                <span class="btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow" data-kt-image-input-action="cancel" data-bs-toggle="tooltip" title="Cancel logo">
                  <i class="ki-duotone ki-cross fs-2">
                    <span class="path1"></span>
                    <span class="path2"></span>
                  </i>
                </span>
                <span class="btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow" data-kt-image-input-action="remove" data-bs-toggle="tooltip" title="Remove logo">
                  <i class="ki-duotone ki-cross fs-2">
                    <span class="path1"></span>
                    <span class="path2"></span>
                  </i>
                </span>
              </div>
              <div class="form-text">Allowed file types: png, jpg, jpeg. Max file size: 5MB.</div>
              <div *ngIf="isLogoUploading" class="d-flex align-items-center mt-3">
                <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                <span class="text-muted">Uploading logo...</span>
              </div>
              <div *ngIf="uploadedLogoUrl && !isLogoUploading" class="d-flex align-items-center mt-3">
                <i class="ki-duotone ki-check-circle fs-2 text-success me-2">
                  <span class="path1"></span>
                  <span class="path2"></span>
                </i>
                <span class="text-success">Logo uploaded successfully</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Two Column Layout -->
      <div class="row">
        <!-- English Column -->
        <div class="col-md-6" formGroupName="english">
          <div class="card border">
            <div class="card-header bg-light border-bottom">
              <h5 class="card-title text-gray-800 mb-0 fw-bold">English</h5>
            </div>
            <div class="card-body">

              <!-- Location Title -->
              <div class="mb-5">
                <label class="form-label">Location Title</label>
                <input type="text" class="form-control form-control-solid" formControlName="location_title" placeholder="Enter location title">
              </div>

              <!-- Company -->
              <div class="mb-5">
                <label class="form-label">Company</label>
                <input type="text" class="form-control form-control-solid" formControlName="company" placeholder="Enter company name">
              </div>

              <!-- Contact Person -->
              <div class="mb-5">
                <label class="form-label">Contact Person</label>
                <input type="text" class="form-control form-control-solid" formControlName="contact_person" placeholder="Enter contact person">
              </div>

              <!-- Address Line 1 -->
              <div class="mb-5">
                <label class="form-label">Address Line 1</label>
                <input type="text" class="form-control form-control-solid" formControlName="address_line_1" placeholder="Enter address line 1">
              </div>

              <!-- Address Line 2 -->
              <div class="mb-5">
                <label class="form-label">Address Line 2</label>
                <input type="text" class="form-control form-control-solid" formControlName="address_line_2" placeholder="Enter address line 2">
              </div>

              <!-- City -->
              <div class="mb-5">
                <label class="form-label">City</label>
                <input type="text" class="form-control form-control-solid" formControlName="city" placeholder="Enter city">
              </div>

              <!-- State -->
              <div class="mb-5">
                <label class="form-label">State</label>
                <input type="text" class="form-control form-control-solid" formControlName="state" placeholder="Enter state">
              </div>

              <!-- Country -->
              <div class="mb-5">
                <label class="form-label">Country</label>
                <input type="text" class="form-control form-control-solid" formControlName="country" placeholder="Enter country">
              </div>

              <!-- Zip -->
              <div class="mb-5">
                <label class="form-label">Zip</label>
                <input type="text" class="form-control form-control-solid" formControlName="zip" placeholder="Enter zip code">
              </div>

              <!-- Telephone -->
              <div class="mb-5">
                <label class="form-label">Telephone</label>
                <input type="text" class="form-control form-control-solid" formControlName="telephone" placeholder="Enter telephone">
              </div>

              <!-- Fax -->
              <div class="mb-5">
                <label class="form-label">Fax</label>
                <input type="text" class="form-control form-control-solid" formControlName="fax" placeholder="Enter fax">
              </div>

              <!-- IP Phone -->
              <div class="mb-5">
                <label class="form-label">IP Phone</label>
                <input type="text" class="form-control form-control-solid" formControlName="ip_phone" placeholder="Enter IP phone">
              </div>

              <!-- Email 1 -->
              <div class="mb-5">
                <label class="form-label">Email 1</label>
                <input type="email" class="form-control form-control-solid" formControlName="email_1" placeholder="Enter email 1">
              </div>

              <!-- Email 2 -->
              <div class="mb-5">
                <label class="form-label">Email 2</label>
                <input type="email" class="form-control form-control-solid" formControlName="email_2" placeholder="Enter email 2">
              </div>

              <!-- Website 1 -->
              <div class="mb-5">
                <label class="form-label">Website 1</label>
                <input type="url" class="form-control form-control-solid" formControlName="website_1" placeholder="Enter website 1">
              </div>

              <!-- Website 2 -->
              <div class="mb-5">
                <label class="form-label">Website 2</label>
                <input type="url" class="form-control form-control-solid" formControlName="website_2" placeholder="Enter website 2">
              </div>

              <!-- WhatsApp Number -->
              <div class="mb-5">
                <label class="form-label">WhatsApp Number</label>
                <input type="text" class="form-control form-control-solid" formControlName="whatsapp_number" placeholder="Enter WhatsApp number">
              </div>

              <!-- Facebook -->
              <div class="mb-5">
                <label class="form-label">Facebook</label>
                <input type="url" class="form-control form-control-solid" formControlName="facebook" placeholder="Enter Facebook URL">
              </div>

              <!-- Google -->
              <div class="mb-5">
                <label class="form-label">Google</label>
                <input type="url" class="form-control form-control-solid" formControlName="google" placeholder="Enter Google URL">
              </div>

              <!-- Twitter -->
              <div class="mb-5">
                <label class="form-label">Twitter</label>
                <input type="url" class="form-control form-control-solid" formControlName="twitter" placeholder="Enter Twitter URL">
              </div>

              <!-- Youtube -->
              <div class="mb-5">
                <label class="form-label">Youtube</label>
                <input type="url" class="form-control form-control-solid" formControlName="youtube" placeholder="Enter Youtube URL">
              </div>

              <!-- LinkedIn -->
              <div class="mb-5">
                <label class="form-label">LinkedIn</label>
                <input type="url" class="form-control form-control-solid" formControlName="linkedin" placeholder="Enter LinkedIn URL">
              </div>

              <!-- Instagram -->
              <div class="mb-5">
                <label class="form-label">Instagram</label>
                <input type="url" class="form-control form-control-solid" formControlName="instagram" placeholder="Enter Instagram URL">
              </div>

              <!-- Comment -->
              <div class="mb-5">
                <label class="form-label">Comment</label>
                <textarea class="form-control form-control-solid" formControlName="comment" rows="4" placeholder="Enter comment"></textarea>
              </div>

              <!-- Priority -->
              <div class="mb-5">
                <label class="form-label fw-semibold">Priority</label>
                <div class="d-flex gap-4 mt-2">
                  <div class="form-check">
                    <input class="form-check-input" type="radio" formControlName="priority" value="1" id="priority1_en">
                    <label class="form-check-label" for="priority1_en">
                      1
                    </label>
                  </div>
                  <div class="form-check">
                    <input class="form-check-input" type="radio" formControlName="priority" value="2" id="priority2_en">
                    <label class="form-check-label" for="priority2_en">
                      2
                    </label>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

        <!-- Japanese Column -->
        <div class="col-md-6" formGroupName="japanese">
          <div class="card border">
            <div class="card-header bg-light border-bottom">
              <h5 class="card-title text-gray-800 mb-0 fw-bold">Japanese</h5>
            </div>
            <div class="card-body">

              <!-- Location Title -->
              <div class="mb-5">
                <label class="form-label">Location Title</label>
                <input type="text" class="form-control form-control-solid" formControlName="location_title" placeholder="Enter location title">
              </div>

              <!-- Company -->
              <div class="mb-5">
                <label class="form-label">Company</label>
                <input type="text" class="form-control form-control-solid" formControlName="company" placeholder="Enter company name">
              </div>

              <!-- Contact Person -->
              <div class="mb-5">
                <label class="form-label">Contact Person</label>
                <input type="text" class="form-control form-control-solid" formControlName="contact_person" placeholder="Enter contact person">
              </div>

              <!-- Address Line 1 -->
              <div class="mb-5">
                <label class="form-label">Address Line 1</label>
                <input type="text" class="form-control form-control-solid" formControlName="address_line_1" placeholder="Enter address line 1">
              </div>

              <!-- Address Line 2 -->
              <div class="mb-5">
                <label class="form-label">Address Line 2</label>
                <input type="text" class="form-control form-control-solid" formControlName="address_line_2" placeholder="Enter address line 2">
              </div>

              <!-- City -->
              <div class="mb-5">
                <label class="form-label">City</label>
                <input type="text" class="form-control form-control-solid" formControlName="city" placeholder="Enter city">
              </div>

              <!-- State -->
              <div class="mb-5">
                <label class="form-label">State</label>
                <input type="text" class="form-control form-control-solid" formControlName="state" placeholder="Enter state">
              </div>

              <!-- Country -->
              <div class="mb-5">
                <label class="form-label">Country</label>
                <input type="text" class="form-control form-control-solid" formControlName="country" placeholder="Enter country">
              </div>

              <!-- Zip -->
              <div class="mb-5">
                <label class="form-label">Zip</label>
                <input type="text" class="form-control form-control-solid" formControlName="zip" placeholder="Enter zip code">
              </div>

              <!-- Telephone -->
              <div class="mb-5">
                <label class="form-label">Telephone</label>
                <input type="text" class="form-control form-control-solid" formControlName="telephone" placeholder="Enter telephone">
              </div>

              <!-- Fax -->
              <div class="mb-5">
                <label class="form-label">Fax</label>
                <input type="text" class="form-control form-control-solid" formControlName="fax" placeholder="Enter fax">
              </div>

              <!-- IP Phone -->
              <div class="mb-5">
                <label class="form-label">IP Phone</label>
                <input type="text" class="form-control form-control-solid" formControlName="ip_phone" placeholder="Enter IP phone">
              </div>

              <!-- Email 1 -->
              <div class="mb-5">
                <label class="form-label">Email 1</label>
                <input type="email" class="form-control form-control-solid" formControlName="email_1" placeholder="Enter email 1">
              </div>

              <!-- Email 2 -->
              <div class="mb-5">
                <label class="form-label">Email 2</label>
                <input type="email" class="form-control form-control-solid" formControlName="email_2" placeholder="Enter email 2">
              </div>

              <!-- Website 1 -->
              <div class="mb-5">
                <label class="form-label">Website 1</label>
                <input type="url" class="form-control form-control-solid" formControlName="website_1" placeholder="Enter website 1">
              </div>

              <!-- Website 2 -->
              <div class="mb-5">
                <label class="form-label">Website 2</label>
                <input type="url" class="form-control form-control-solid" formControlName="website_2" placeholder="Enter website 2">
              </div>

              <!-- WhatsApp Number -->
              <div class="mb-5">
                <label class="form-label">WhatsApp Number</label>
                <input type="text" class="form-control form-control-solid" formControlName="whatsapp_number" placeholder="Enter WhatsApp number">
              </div>

              <!-- Facebook -->
              <div class="mb-5">
                <label class="form-label">Facebook</label>
                <input type="url" class="form-control form-control-solid" formControlName="facebook" placeholder="Enter Facebook URL">
              </div>

              <!-- Google -->
              <div class="mb-5">
                <label class="form-label">Google</label>
                <input type="url" class="form-control form-control-solid" formControlName="google" placeholder="Enter Google URL">
              </div>

              <!-- Twitter -->
              <div class="mb-5">
                <label class="form-label">Twitter</label>
                <input type="url" class="form-control form-control-solid" formControlName="twitter" placeholder="Enter Twitter URL">
              </div>

              <!-- Youtube -->
              <div class="mb-5">
                <label class="form-label">Youtube</label>
                <input type="url" class="form-control form-control-solid" formControlName="youtube" placeholder="Enter Youtube URL">
              </div>

              <!-- LinkedIn -->
              <div class="mb-5">
                <label class="form-label">LinkedIn</label>
                <input type="url" class="form-control form-control-solid" formControlName="linkedin" placeholder="Enter LinkedIn URL">
              </div>

              <!-- Instagram -->
              <div class="mb-5">
                <label class="form-label">Instagram</label>
                <input type="url" class="form-control form-control-solid" formControlName="instagram" placeholder="Enter Instagram URL">
              </div>

              <!-- Comment -->
              <div class="mb-5">
                <label class="form-label">Comment</label>
                <textarea class="form-control form-control-solid" formControlName="comment" rows="4" placeholder="Enter comment"></textarea>
              </div>

              <!-- Priority -->
              <div class="mb-5">
                <label class="form-label fw-semibold">Priority</label>
                <div class="d-flex gap-4 mt-2">
                  <div class="form-check">
                    <input class="form-check-input" type="radio" formControlName="priority" value="1" id="priority1_jp">
                    <label class="form-check-label" for="priority1_jp">
                      1
                    </label>
                  </div>
                  <div class="form-check">
                    <input class="form-check-input" type="radio" formControlName="priority" value="2" id="priority2_jp">
                    <label class="form-check-label" for="priority2_jp">
                      2
                    </label>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>

      <!-- Submit Button -->
      <div class="row mt-8">
        <div class="col-12 text-center">
          <button type="submit" class="btn btn-primary" [disabled]="isLoading">
            <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
            {{ isLoading ? 'Updating...' : 'Update' }}
          </button>
        </div>
      </div>

    </form>
  </div>
</div>
